import { Typography } from '@mui/material'
import PropTypes from 'prop-types'

const classes = {
    title: {
        fontWeight: 500,
        fontSize: ['14px', '18px'],
        lineHeight: ['16px', '21px'],
        textTransform: 'uppercase',
        color: 'text.primary',
    },
}

const TbxToolbarTitle = ({ children, sx = null }) => {
    return <Typography sx={[classes.title, ...(Array.isArray(sx) ? sx : [sx])]}>{children}</Typography>
}

TbxToolbarTitle.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
}

export default TbxToolbarTitle
